import { render, staticRenderFns } from "./QuizAssignment.vue?vue&type=template&id=52cf38da"
import script from "./QuizAssignment.vue?vue&type=script&lang=js"
export * from "./QuizAssignment.vue?vue&type=script&lang=js"
import style0 from "./QuizAssignment.vue?vue&type=style&index=0&id=52cf38da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports